<template>
    <!-- Error page can load without global page data -->
    <div v-if="showErrorPage">
        <ErrorPageContent />
    </div>

    <div v-else class="container">
        <h1 id="titleTextId">You are pre-approved for the offers below. Accept Now.</h1>

        <IndependentOfferBlock
            class="independent-offer-block"
            :offers="offers"
            :pqdisclosure="pageData.pqdisclosure"
            :optout="pageData.optout"
            :offerOrder="pageData.offer_order"
            :annualLinkTarget="pageData.annualLinkTarget"
            :ctaLinkTarget="pageData.CTALinkTarget"
        />

        <div class="d-flex justify-content-center">
            <a class="noTanks" @click="closeWindow()">No thanks</a>
        </div>

        <div class="pt-4">
            <!--Short Opt Out-->
            <div class="optout desktop" v-html="pageData.optout"></div>
            <br />

            <!--Global-->
            <div class="global" v-html="pageData.global"></div>

            <div class="pqDisclosure" v-html="pageData.pqdisclosure"></div>

            <div class="optOutLong" v-html="pageData.optoutlong"></div>
        </div>
    </div>

    <IndependentFooter :footermessage="pageData.footermessage" />
</template>

<script>
import { useStore } from 'vuex'
import { useRouter } from 'vue-router'

export default {
    props: ['offers', 'pageData'],
    setup() {
        const store = useStore()
        const router = useRouter()

        return {
            router,
            store,
        }
    },
    computed: {
        showErrorPage: function () {
            if (this.store.state.global.data.showErrorPage && this.pageData.noofferurl) {
                window.location.replace(this.pageData.noofferurl)
            }

            return this.store.state.global.data.showErrorPage
        },
    },
    methods: {
        closeWindow: function () {
            window.close()
        },
    },
}
</script>

<style lang="scss">
@import '~scss/mixins/rem';
@import '~scss/settings/responsive';

h1,
h2,
h3,
h4,
h5,
h6,
.pqDisclosure p,
.optout p,
.global {
    font-family: Arial, sans-serif;

    &input,
    &textarea,
    &.uneditable-input,
    &button,
    &select,
    &textarea,
    &label,
    .global {
        font-family: Arial, sans-serif;
    }
}

h1,
h2,
h3,
h4,
h5,
h6,
label,
.label,
.pqDisclosure p,
.optout p {
    color: #535353;
}

h1,
h2,
h3,
h4,
h5,
h6 {
    &.underline {
        border-bottom-color: #dfedf5;
    }
}

h1,
h2,
h5 {
    font-size: 30px;
    font-weight: normal;
    color: #19398a;
}

a {
    color: #19398a;
    text-decoration: none;
}

a.visited {
    color: #19398a;
}

#titleTextId {
    margin-top: 50px;
    color: #19398a;
    font-size: 52px;
    font-family: Arial, sans-serif;
    line-height: 57px;

    @media (max-width: 767px) {
        font-size: 30px;
        line-height: 40px;
    }
}

.optout {
    font-size: 1.3em;
    font-weight: 400;
    border: 1px solid #000;
    padding: 15px;
    font-style: italic;

    @media (max-width: 767px) {
        font-size: 1em;
    }

    &.desktop {
        display: block;

        @media (max-width: $bp-medium) {
            display: none;
        }
    }
}

.optOutLong p {
    font-size: 1.3em;
    font-weight: 600;
    padding: 30px;
    color: #535353;
    font-family: Arial, sans-serif;
    word-wrap: break-word;

    @media (max-width: 767px) {
        font-size: 1em;
    }
}

.independent-offer-block {
    padding: 0 0 40px 0;
}

.global p {
    font-family: Arial, sans-serif;
    font-size: 1em;

    @media (max-width: 767px) {
        font-size: 0.8em;
    }
}

#headerWrapper {
    height: 95px;

    #headerMain {
        height: 95px;
        border-bottom: none;
        padding-left: 0;
        padding-right: 0;

        #headerLogo {
            height: 74px;
            width: 350px;
            margin-top: 10px;
            margin-left: -15px;
            background-repeat: no-repeat;

            @media (max-width: 767px) {
                display: block;
                margin-left: auto;
                margin-right: auto;
                float: none;
                background-size: initial;
                height: 58px;
                width: 275px;
            }
        }

        #applicationName,
        #headerRightContent {
            display: none;
        }
    }
}

.noTanks {
    cursor: pointer;
    transition: all 0.2s ease-in-out;

    &:hover {
        transform: scale(1.2);
    }
}

sup.pointer {
    cursor: pointer;
}
</style>
